import React = require("react");
import ReactDOM = require("react-dom");

import features = require("diy/util/features");
import NotificationApi from "diy/toolbar/notificationNG/Api";
let SiteAdminApi = require<any>("diy/site-admin/main/api");

export type DialogActions = (React.ReactElement<any> | __MaterialUI.DialogAction)[];

interface DialogViewProps {
    dialog: React.ReactElement<React.Props<any>>;
}

export class DialogView extends React.Component<DialogViewProps, {}> {
    private actions: DialogActions;
    private content: JSX.Element;
    private container: HTMLElement;

    setContent(content: JSX.Element) {
        this.content = content;
    }

    setActions(actions: DialogActions) {
        this.actions = actions;
    }

    getContainer(): HTMLElement {
        if (! this.container) {
            let container = document.createElement("div");
            document.body.appendChild(container);
            this.container = container;
        }
        return this.container;
    }

    render() {
        let type: string = this.props.dialog.type as string;
        let props: any = Object.assign({}, this.props.dialog.props);
        let children = this.props.dialog.props.children as JSX.Element;

        if (typeof this.actions !== "undefined") {
            props.actions = this.actions;
        }

        if (typeof this.content !== "undefined") {
            children = this.content;
        }

        return (
            React.createElement(type, props, children)
        );
    }

    create(callback: Function) {
        ReactDOM.render(
            this.render(),
            this.getContainer(),
            () => {
                callback(true);
            }
        );
    }

    destroy() {
        ReactDOM.unmountComponentAtNode(
            this.getContainer()
        );
    }
}

export default class DialogController {
    private dialogView: DialogView;

    getDialogView(): DialogView {
        return this.dialogView;
    }

    open(
        dialog: React.ReactElement<React.Props<any>>,
        content?: JSX.Element,
        actions?: DialogActions
    ): Promise<void> {

        SiteAdminApi.close();

        this.dialogView = new DialogView({
            dialog: dialog
        });
        return this.update(content, actions);
    }

    close() {
        this.dialogView.destroy();

        if (features("notificationsNG")) {
            NotificationApi.schedule(() => {
                NotificationApi.resume();
            });
        }
    }

    update(
        content?: JSX.Element,
        actions?: DialogActions
    ): Promise<void> {

        if (typeof content !== "undefined") {
            this.dialogView.setContent(content);
        }
        if (typeof actions !== "undefined") {
            this.dialogView.setActions(actions);
        }
        return new Promise<void>((resolve, reject) => {
            if (features("notificationsNG")) {
                NotificationApi.schedule(() => {
                    NotificationApi.pause().then(() => {
                        this.dialogView.create(resolve);
                    });
                });
            } else {
                this.dialogView.create(resolve);
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/DialogController.tsx
 **/